export const GET_PERSONAL_INFO = "GET_PERSONAL_INFO";
export const UPDATE_PERSONAL_INFO = "UPDATE_PERSONAL_INFO";

export const UPDATE_PERSONAL_DETAIL = "UPDATE_PERSONAL_DETAIL";
export const SET_PERSONAL_INFO_DROPDOWN = "SET_PERSONAL_INFO_DROPDOWN";
export const UPDATE_PERSONAL_OTHER_DETAIL = "UPDATE_PERSONAL_OTHER_DETAIL";

//GETINCOMEPROOF
export const GET_INCOMEPROOF_DETAILS = "GET_INCOMEPROOF_DETAILS";
export const UPDATE_INCOMEPROOF_DETAIL = "UPDATE_INCOMEPROOF_DETAIL";
export const SET_INCOMEPROOF_INFO_DROPDOWN = "SET_INCOMEPROOF_INFO_DROPDOWN";

export const GET_NOMINEE_GENDER = "GET_NOMINEE_GENDER";
export const GET_NOMINEE_DOCUMENT_TYPE = "GET_NOMINEE_DOCUMENT_TYPE";
export const GET_NOMINEE_RELATIONSHIP = "GET_NOMINEE_RELATIONSHIP";

export const GET_NOMINEE_TYPE = "GET_NOMINEE_TYPE";
export const GET_SELECTEDSEGMENT = "GET_SELECTEDSEGMENT";
export const GET_DPTARIFF = "GET_DPTARIFF";

// CRM (branch) "DP Scheme" dropdown on Additional Details — saved on change.
export const SET_DP_SCHEME = "SET_DP_SCHEME";               // from GET /personal-details
export const DP_SCHEME_CHANGE = "DP_SCHEME_CHANGE";         // user picked a value (optimistic)
export const DP_SCHEME_SAVED = "DP_SCHEME_SAVED";           // PUT resolved (applied or stale)
export const DP_SCHEME_SAVE_FAILED = "DP_SCHEME_SAVE_FAILED"; // PUT rejected / network error

// GETPERSONALDETAILS Us Equity

export const GET_PERSONAL_DETAILS_USEQUITY = "GET_PERSONAL_DETAILS_USEQUITY";
export const UPDATE_PERSONAL_DETAILS_USEQUITY = "UPDATE_PERSONAL_DETAILS_USEQUITY";
export const UPDATE_PERSONAL_INFO_USEQUITY = "UPDATE_PERSONAL_INFO_USEQUITY";
export const GET_PERSONAL_INFO_USEQUITY = "GET_PERSONAL_INFO_USEQUITY";
export const SET_PERSONAL_INFO_USEQUITY_DROPDOWN = "SET_PERSONAL_INFO_USEQUITY_DROPDOWN";
